<template>
    <div>
        <v-dialog v-model="dialog" max-width="400px" persistent>
            <v-card class="elevation-16 mx-auto">
                <v-card-title class="headline" primary-title>
                    {{ $t('common.report') + targetUser.fullname}}
                </v-card-title>

                <v-card-text>
                    <div class="text-center mt-12">
                        <v-textarea v-model="report" v-bind:label="$t('common.report_content')" outlined>
                        </v-textarea>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-space-between">
                    <v-btn dark color="primary" @click="closeReport"> {{ $t('common.cancel') }}</v-btn>
                    <v-btn dark color="primary" @click="reportUser">
                        {{ $t('common.send') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';

    export default {
        name: 'report-dialog',

        components: {
        },

        data: ()=> ({
            report: ''
        }),

        watch: {
        },

        props: {
            dialog: Boolean,
            targetUser: Object,
            designRequest: Object
        },

        methods: {
            closeReport() {
                this.$emit('closeDialog', false);
            },

            async reportUser() {
                if (!this.report || this.report === '') {
                    alert(i18n.t('validate.report_empty'))
                }
                try {
                    const requestBody = {
                        targetUser: this.targetUser._id,
                        note: this.report, 
                        designRequest: this.designRequest._id,
                    }

                    const response = await this.$http.post(process.env.VUE_APP_CREATE_REPORT_API, requestBody);

                    if (response.data && response.data.success) {
                        this.$fire({
                            title: i18n.t('common.report_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                            this.closeReport();
                        });
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            },
        }
    }
</script>
